<div class="trip-list">
    <div class="trip-list__header">
        <h1 class="trip-list__header--title">
            {{ trip.name }}
        </h1>
        <div class="trip-list__header--row">
            <div class="trip-list__header--text">
                {{ trip.tripData.duration }} days
            </div>
        </div>

        @if (trip.blogUrl) {
            <div class="trip-list__header--switcher">
                <app-switcher
                        [isDynamicWidth]="true"
                        [selectedIndex]="0"
                        [switcherConfig]="[
                            { label: 'Overview', parameter: eRoutes.OVERVIEW },
                            { label: 'Day by day', parameter: eRoutes.DAY_BY_DAY }
                        ]"
                ></app-switcher>
            </div>
        }

        <p class="trip-list__header--description">
            {{trip.description}}
        </p>

        <div class="trip-list__header--plan">
            <button class="btn-default btn-orange btn-mobile" (click)="makeItMyTripPlanHandler()">
                Make it My Plan
            </button>
        </div>
    </div>
    <div class="trip-list__content">
        <div class="trip-list__content--map">
            <app-preview-map
                    [savedTripView]="true"
                    [showMapControls]="false"
                    [destinationsRoute]="destinationsRoute"
                    (tripLegs)="setParsedTripLegs($event)"
            ></app-preview-map>
        </div>

        <div class="trip-list__content--list">
            @for (route of trip.tripData.route; track route; let idx = $index; let last = $last) {
                <div class="trip-card">
                    <div class="trip-card__header">
                        @if (route.imageUrl) {
                            <figure>
                                <img [src]="route.imageUrl | safeUrl" alt="image">
                            </figure>
                        }
                    </div>
                    <div class="trip-card__content">

                        <div class="trip-card__justify">
                            <div class="trip-card__row col start">
                                <h3>{{ route.name }}</h3>
                            </div>

                            <div class="trip-card__row col end">
                                <div class="trip-card__night">
                                    <span class="trip-card__night--bold">{{ route.days }}</span>
                                    <span>Nights</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                @if (!last && legs.length && legs[idx]; as leg) {
                    <div class="leg-box">
                        <div class="leg-box__pseudo"><span></span></div>
                        <span class="leg-box__duration">
                            {{ leg.dist + ' | ' + leg.time }}
                        </span>
                    </div>
                }
            }
        </div>
    </div>
</div>
